module.exports = __webpack_public_path__ + "static/media/KMH_5336.195fd605.jpg";